var Backbone = require('backbone');
var $ = require('jquery');
var template = require('../templates/geo.ejs');


module.exports = Backbone.View.extend({
    className: 'geo',

    /**
     *
     */
    render: function () {

        this.$el.html(template(this.model));
        $('footer').addClass('posfix');

        return this;
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/geo.js
// module id = 246
// module chunks = 0